import helpCenter from '@sv-support-sdk/api/src/modules/helpCenter';
import community from '@sv-support-sdk/api/src/modules/community';
import tickets from '@sv-support-sdk/api/src/modules/tickets';

import user from './modules/user';
import search from './modules/search';
import survey from './modules/survey';
import session from './modules/session';

import instance from './instance';

export default {
  helpCenter: helpCenter(instance),
  community: community(instance),
  tickets: tickets(instance),
  search,
  user,
  survey,
  session,
};
